$( document ).ready(function() {
  $(".site-nav__link--icon-wishlist").click(function(){
    setTimeout(() => {
      $(".wishlist-move-cart").click(function(){
        setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:build'));
        }, "1000");
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        }, "2000");
      });  
    }, "1500");
  });
});